<template>
    <div class="route-list-wrapper">
        <div ref="wrapper" class="route-list">
            <div ref="line" class="dashed-line"></div>
            <table
                v-for="(route, index) in renderRoutes"
                :key="index"
                class="route-item"
                :class="{ first: index === 0, last: index === renderRoutes.length - 1 }"
            >
                <tr ref="tr">
                    <td class="route-left">
                        <span :class="{ signed: route.opState.type === 'signed' }">{{ route.opState.name }}</span>
                    </td>
                    <td class="route-center"><img :src="route.imgUrl" :class="route.imgClass" alt="运单路由图片" /></td>
                    <td class="route-right">
                        <p class="time">{{ route.scanDateTime }}</p>
                        <p v-html="route.remark"></p>
                    </td>
                </tr>
            </table>
        </div>
        <div v-if="showLoadingMore" class="load-more" @click="loadMore()">
            <span>点击加载更多</span>
            <icon name="arrow-down"></icon>
        </div>
    </div>
</template>

<script>
import moment from 'moment'
import { containMobileReg } from '@/util/regs'
export default {
    name: 'WaybillRoute',
    props: {
        routes: {
            // 父组件传过来的路由原始数据
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            imgFlag: ['collect-cur', 'delivery', 'signed', 'collect', 'transporting'],
            showLoadingMore: false // 是否显示加载更多
        }
    },
    computed: {
        // 处理路由数据
        routesArr() {
            const arr = []
            const maxIndex = this.routes.length - 1
            this.routes.forEach((obj, index) => {
                arr.push(this.handlerRouteInfo(obj, index, maxIndex))
            })
            return arr
        },
        // 获取渲染的路由
        renderRoutes() {
            if (this.showLoadingMore) {
                return this.routesArr.slice(0, 6)
            } else {
                return this.routesArr
            }
        },
        // 加载的路由小图标的对象
        imagesObj() {
            const obj = {}
            this.imgFlag.forEach(flag => {
                obj[flag] = require(`../../../assets/images/waybill/status-${flag}.png`)
            })
            return obj
        }
    },
    created() {
        this.calcIfLoadingMore()
    },
    mounted() {
        this.bindCalcDashedLine()
    },
    updated() {
        this.calcDashedLine()
    },
    methods: {
        // 计算是否显示点击加载更多
        calcIfLoadingMore() {
            if (this.routesArr.length > 5) {
                this.showLoadingMore = true
            }
        },
        // 处理路由数据
        handlerRouteInfo(route, index, maxIndex) {
            const obj = {
                scanDateTime: moment(route.scanDateTime).format('YYYY-MM-DD HH:mm'),
                remark: '',
                opState: this.$parent.getStatusByOpcode(route)
            }
            const imgIndex = this.getImageIndex(obj.opState.type, index, maxIndex)
            obj.imgClass = this.imgFlag[imgIndex]
            obj.imgUrl = this.imagesObj[obj.imgClass]
            if (route.remark) {
                let remark = route.remark.replace('id="opr_phone"', 'class="route-phone"')
                if (obj.opState.type === 'delivery') {
                    const reg = new RegExp(containMobileReg, 'g')
                    remark = remark.replace(reg, mobileNo => `<a href="tel:${mobileNo}">${mobileNo}</a>`)
                }
                obj.remark = remark
            }
            return obj
        },

        // 分别获取每个路由节点的图片路径
        getImageIndex(type, index, maxIndex) {
            let imgIndex
            if (index === 0) {
                if (type === 'collect' || type === 'pickedup') {
                    imgIndex = 0
                } else if (type === 'delivery' || type === 'other' || type === 'invalid') {
                    imgIndex = 1
                } else if (type === 'signed') {
                    imgIndex = 2
                } else {
                    imgIndex = 4
                }
            } else if (index === maxIndex) {
                if (maxIndex > 0 && (type === 'collect' || type === 'pickedup')) {
                    imgIndex = 3
                } else {
                    imgIndex = 4
                }
            } else {
                imgIndex = 4
            }
            return imgIndex
        },
        // 屏幕发生改变的时候改变虚线
        bindCalcDashedLine() {
            this.calcDashedLine()
            window.addEventListener('resize', () => {
                this.calcDashedLine()
            })
        },
        // 计算竖线的高度和top
        calcDashedLine() {
            const height =
                this.$refs.wrapper.clientHeight - (this.$refs.tr[0].clientHeight + this.$refs.tr[this.$refs.tr.length - 1].clientHeight) / 2
            const top = this.$refs.tr[0].clientHeight / 2
            this.$refs.line.style.top = `${top}px`
            this.$refs.line.style.height = `${height}px`
        },
        // 点击加载更多
        loadMore() {
            this.showLoadingMore = false
        }
    }
}
</script>

<style lang="scss" scoped>
.route-list-wrapper {
    margin: 35px 0 35px;
}
.route-list {
    position: relative;
}
.dashed-line {
    position: absolute;
    border-right: 4px dashed $gray-light;
    left: calc(22.5% - 2px);
    z-index: -1;
}
.route-item {
    color: $gray;
    margin-bottom: 20px;
    width: 100%;
    &.first {
        color: $black;
    }
    &.last {
        img {
            &.transporting {
                width: 80%;
            }
        }
    }
    .signed {
        color: $red;
    }
    .time {
        color: $black;
    }
}
.route-left {
    width: 15%;
    text-align: right;
}
.route-center {
    width: 15%;
    text-align: center;
    img {
        width: 80%;
        vertical-align: middle;
        &.transporting {
            width: 40%;
        }
    }
}
.route-right {
    width: 70%;
}
.load-more {
    display: block;
    text-align: center;
    color: $gray;
    padding-top: 40px;
    .icon-arrow-down {
        height: 30px;
        margin-left: 15px;
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/waybill/waybillDetail/waybill-route.vue